import NextLink from 'next/link';
import { Box, Button, Container, Grid, Typography, useTheme, alpha } from '@mui/material';
import { ExternalLink as ExternalLinkIcon } from '../../icons/external-link';
import { Logo } from '../logo';
import { Login } from '@mui/icons-material';

export const HomeDevelopers = (props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // Uso de un gradiente sutil basado en los colores del tema para dar profundidad
        background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${alpha(theme.palette.primary.main, 0.05)} 100%)`,
        py: { xs: 8, md: 15 }, // Espaciado responsive
        minHeight: '100vh', // Asegura que cubra la pantalla en monitores grandes
        display: 'flex',
        alignItems: 'center',
      }}
      {...props}
    >
      <Container maxWidth="lg">
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          spacing={6} // Aumenté el espaciado entre columnas para que "respire" mejor
        >
          {/* Columna de Texto */}
          <Grid
            item
            md={6}
            xs={12}
            sx={{
              order: { xs: 2, md: 1 },
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            <Box>
              {/* Contenedor del Logo con tamaño controlado */}
              <Box
                sx={{
                  width: { xs: '180px', md: '220px' }, // Tamaño fijo para consistencia
                  mb: 3,
                  mx: { xs: 'auto', md: 0 },
                }}
              >
                <Logo variant="dark" />
              </Box>

              <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, color: 'text.primary' }}>
                Portal Corporativo
              </Typography>

              <Typography
                color="textSecondary"
                sx={{ mb: 4, maxWidth: '500px', mx: { xs: 'auto', md: 0 } }}
                variant="subtitle1"
              >
                Bienvenido al sistema interno de <strong>ELAM-FAW</strong>. Esta plataforma es de
                uso exclusivo para personal autorizado. Si ha llegado aquí por error, le sugerimos
                regresar al sitio público.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' }, // En móbiles los botones se apilan
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  gap: 2, // Uso de gap en lugar de margin left para mejor control
                }}
              >
                <NextLink href="/dashboard" passHref>
                  <Button
                    endIcon={<Login fontSize="small" />}
                    size="large"
                    variant="contained"
                    sx={{
                      px: 4,
                      boxShadow: theme.shadows[8], // Sombra elegante
                      '&:hover': {
                        boxShadow: theme.shadows[12],
                        transform: 'translateY(-2px)', // Pequeño efecto de elevación
                      },
                      transition: 'all 0.3s',
                    }}
                  >
                    Iniciar sesión
                  </Button>
                </NextLink>

                <NextLink href="https://faw.mx" passHref>
                  <Button
                    endIcon={<ExternalLinkIcon fontSize="small" />}
                    size="large"
                    variant="outlined"
                    sx={{ px: 3 }}
                  >
                    Sitio web público
                  </Button>
                </NextLink>
              </Box>
            </Box>
          </Grid>

          {/* Columna de Imagen */}
          <Grid item md={6} sm={8} xs={12} sx={{ order: { xs: 1, md: 2 } }}>
            <Box
              sx={{
                position: 'relative',
                pt: 'calc(960 / 1225 * 100%)',
                '& img': {
                  height: 'auto',
                  position: 'absolute',
                  top: 0,
                  width: '100%',
                },
              }}
            >
              <img alt="For developers" src={`/static/home/conocenos.png`} />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
